module.exports = __webpack_public_path__ + "img/icon_transport.3b9ceff6.svg";